import React from 'react';
import T from 'prop-types';

import Modal from '../../../Modal';
import Button from '../../../Buttons/Button';

const SaveChangesModal = ({
  open,
  title = 'Save changes?',
  description = 'There are unsaved changes in this export',
  confirmButtonText = 'Save changes',
  onConfirm,
  onClose,
}) => (
  <Modal
    open={open}
    size="xs"
    closeButtonIconClass="hicon-close-2"
    modalClassName="upsert-export-modal cancel-upsert-modal"
    onClose={onClose}
  >
    <div className="upsert-export-modal__body">
      <h3 className="upsert-export-modal__title">{title}</h3>
      <small className="upsert-export-modal__description">{description}</small>
    </div>

    <div className="upsert-export-modal__footer">
      <Button
        size="lg"
        variant="light"
        href="/my_reports#exports"
        className="text-red"
      >
        Discard changes
      </Button>
      <Button
        size="lg"
        onClick={() => onConfirm()}
      >
        {confirmButtonText}
      </Button>
    </div>
  </Modal>
);

SaveChangesModal.propTypes = {
  open: T.bool.isRequired,
  title: T.string,
  description: T.string,
  confirmButtonText: T.string,
  onConfirm: T.func.isRequired,
  onClose: T.func.isRequired,
};

export default SaveChangesModal;
